import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AdminHeaderComponent } from './components/admin-header.component';
import { getCurrentUser } from '../../shared/utils/auth.utils';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule, AdminHeaderComponent],
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit, OnDestroy {
  userPermissions: string[] = [];
  private permissionsSub: Subscription;

  constructor(private authService: AuthService) {
    // Initialiser les permissions depuis le service immédiatement
    this.userPermissions = this.authService.getPermissions();
  }

  ngOnInit() {
    // Charger les permissions si elles ne sont pas déjà chargées
    if (this.userPermissions.length === 0) {
      this.authService.initializeAuthState();
    }

    // S'abonner aux changements de permissions
    this.permissionsSub = this.authService.permissions$.subscribe(
      permissions => {
        this.userPermissions = permissions;
      }
    );

    // Forcer une vérification des permissions
    this.authService.checkPermissions();
  }

  ngOnDestroy() {
    if (this.permissionsSub) {
      this.permissionsSub.unsubscribe();
    }
  }

  hasAnyPermission(permissions: string[]): boolean {
    if (!this.userPermissions || this.userPermissions.length === 0) {
      // Si les permissions ne sont pas encore chargées, recharger
      this.authService.checkPermissions();
      return false;
    }
    return this.userPermissions.some(permission => permissions.includes(permission));
  }
}